<template>
  <!-- viewer product list -->
  <div class="itemBox">
    <div class="itemList" :class="{ expand_itemList: allItems }">
      <div
        v-if="
          allItems && !$store.state.noLive && $store.state.broadCastProductList
        "
        class="itemCard_Panel"
        v-for="(data, key) in $store.state.broadCastProductList"
      >
        <div class="itemCards">
          <img :src="data.itemImage || data.displayImage" />
          <span class="buyers_count"
            >{{ orderIdview === data.ordered_id ? viewClicked : data.view }}
            {{ $t('boughtthisdeal') }}</span
          >
          <span class="your_amount">{{
            data.itemName || data.productName
          }}</span>
          <span class="item_amount">
            ₹ {{ data.totalPaidAmount || data.sellingPrice }}
            <span class="actual_amount">
              ₹ {{ data.sellingPrice || data.markedPrice }}</span
            >
          </span>
          <div class="golive_btn">
            <button
              @click="uncheckedPrdt(key, data.ordered_id, data.saleReferenceID)"
              type="button"
              class="btn_red"
            >
              {{ $t('makeLive') }}
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="!allItems && $store.state.broadCastProductListLive"
        class="itemCard_Panel"
      >
        <div class="itemCards">
          <img
            :src="
              $store.state.broadCastProductListLive.itemImage ||
                $store.state.broadCastProductListLive.displayImage
            "
          />
          <span class="buyers_count"
            >{{
              $store.state.broadCastProductListLive.view ||
                $store.state.broadCastProductListLive.viewersCount
            }}
            {{ $t('boughtthisdeal') }}</span
          >
          <span class="your_amount">{{
            $store.state.broadCastProductListLive.itemName ||
              $store.state.broadCastProductListLive.productName
          }}</span>
          <span class="item_amount">
            ₹
            {{
              $store.state.broadCastProductListLive.totalPaidAmount ||
                $store.state.broadCastProductListLive.sellingPrice
            }}
            <span class="actual_amount">
              ₹
              {{
                $store.state.broadCastProductListLive.sellingPrice ||
                  $store.state.broadCastProductListLive.markedPrice
              }}</span
            >
          </span>
          <!-- <div class="golive_btn">
            <button type="button" class="btn_red">लाइव करे</button>
          </div> -->
        </div>
      </div>
      <div v-if="!allItems && $store.state.noLive" class="itemCard_Panel">
        <div class="itemCards">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTQazJBcUCwI50Edc-BD7s-nEYCxTEb5gJ9pwlyx98daW1tqVSV"
          />
          <span class="buyers_count">{{ $t('noProduct') }}</span>
        </div>
      </div>
    </div>
    <!-- allItems = !allItems -->
    <div class="more_item" @click="moreItems" v-if="!$store.state.noLive">
      <span v-if="!allItems"
        >{{ $t('MoreItem') }}
        <i class="material-icons">dehaze</i>
      </span>
      <span v-if="allItems"
        >{{ $t('Close') }}
        <i class="material-icons">close</i>
      </span>
    </div>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
export default {
  name: 'BroadCasterProductListLive',
  props: ['channel', 'xAuthId'],
  data() {
    return {
      productlist: [],
      noLive: false,
      allItems: false,
      activePrdt1: false,
      selectedInex: 0,
      shoppingActive: false,
      viewClicked: '',
      orderIdview: '',
      moreOpen: false,
      isLoading: false,
      orderId: ''
    }
  },
  mounted() {
    console.log(
      '=-=-this.$store.state && this.$store.state.broadCastProductListLive-=-=',
      this.$store.state && this.$store.state.broadCastProductListLive
    )
    this.productlist =
      this.$store.state && this.$store.state.broadCastProductListLive
  },
  methods: {
    moreItems() {
      this.allItems = !this.allItems
      this.moreOpen = true
    },
    uncheckedPrdt(index, orderId, saleReferenceID) {
      console.log(
        '====--this.$store--live list ',
        this.$store.state,
        orderId,
        saleReferenceID
      )
      this.selectedInex = index
      let obj = {
        room_id: this.channel,
        x_auth_id: this.xAuthId
      }
      if (!orderId) {
        obj.saleReferenceID = saleReferenceID
      } else {
        obj.ordered_id = orderId
      }
      // this.shoppingActive = false
      console.log('---=obj=---', obj)
      this.$socket.emit('broadcaster_live_product', obj)
      this.$emit('livedProduct')
      this.allItems = false
    }
  },
  sockets: {
    broadcaster_ordered_history: function(data) {
      console.log('=--=-=shubham-data-=', data)
      if (data.data.length > 0) {
        this.noLive = false
        this.isLoading = false
        this.$store.commit('broadCastProductList', data.data)
        this.productlist =
          this.$store.state && this.$store.state.broadCastProductList
        this.$store.commit('noLive', this.noLive)
      } else {
        this.noLive = true
        this.$store.commit('noLive', this.noLive)
      }
      if (this.productlist.length > 0) this.shoppingActive = true
    },
    view: function(data) {
      console.log('--===--', data)
      this.viewClicked = data.view
      this.orderIdview = data.ordered_id
    },
    new_live_product: function(data) {
      this.$toast.top('New Product has been live')
      this.shoppingActive = true
      this.$emit('true')
      this.$store.commit('broadCastProductListLive', data.data)
      // this.viewerProductList = data.data
    }
  }
}
</script>
